/**
 * Resolves the stable key of a metric table row.
 *
 * Plan metrics arrive keyed on `attributeExId` (dimension sub-mode) or `kpi_id`
 * (metric sub-mode), promo metrics on `id`. `MetricTable` uses this for the AntD
 * `rowKey` and the row test id, and the column builders use it for cell test ids,
 * so both sides address the same row with the same value.
 *
 * Returns `undefined` when the row carries no stable key: callers must omit the
 * test id in that case rather than substitute an unstable one.
 */
export interface MetricRowKeyFields {
    id?: string;
    kpi_id?: string;
    attributeExId?: string;
    key?: string;
}

export const resolveMetricRowKey = (row: MetricRowKeyFields): string | undefined =>
    row.id ?? row.kpi_id ?? row.attributeExId ?? row.key;
